/**
 * @file Nombre de archivo sugerido para el PDF del CV (cliente).
 * @module cvPdfFilename
 */

/**
 * @param {unknown} value
 * @param {number} [maxLen]
 * @returns {string}
 */
function slugifyForCvFilename(value, maxLen = 48) {
	return String(value ?? "")
		.trim()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.slice(0, maxLen)
		.replace(/-+$/g, "");
}

/**
 * Nombre sugerido (`cv-nombre-apellido-idioma.pdf`).
 * @param {{ firstName?: unknown, lastName?: unknown }} data
 * @param {"en" | "es"} locale
 * @returns {string}
 */
export function buildCvPdfFilename(data, locale) {
	const fn = slugifyForCvFilename(data.firstName);
	const ln = slugifyForCvFilename(data.lastName);
	const idiom = locale === "en" ? "ingles" : "espanol";
	if (!fn && !ln) return `cv-${idiom}.pdf`;
	if (!fn) return `cv-${ln}-${idiom}.pdf`;
	if (!ln) return `cv-${fn}-${idiom}.pdf`;
	return `cv-${fn}-${ln}-${idiom}.pdf`;
}
